import type { FC, SVGProps } from 'react'

export const EducationPitchExtraction: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="5" cy="6" r="2.25" stroke="white" strokeWidth="1.5" />
    <circle cx="27" cy="9" r="2.25" stroke="white" strokeWidth="1.5" />
    <path
      d="M24 9H18L14 6H8"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="5" cy="14" r="2.25" stroke="url(#paint0_linear_4078_19797)" strokeWidth="1.5" />
    <circle cx="27" cy="17" r="2.25" stroke="url(#paint1_linear_4078_19797)" strokeWidth="1.5" />
    <path
      d="M24 17H18L14 14H8"
      stroke="url(#paint2_linear_4078_19797)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="5" cy="22" r="2.25" stroke="white" strokeWidth="1.5" />
    <circle cx="27" cy="25" r="2.25" stroke="white" strokeWidth="1.5" />
    <path
      d="M24 25H18L14 22H8"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4078_19797"
        x1="5"
        y1="11"
        x2="5"
        y2="17"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#63FFD1" />
        <stop offset="1" stopColor="#63FFD1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4078_19797"
        x1="27"
        y1="14"
        x2="27"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#63FFD1" />
        <stop offset="1" stopColor="#63FFD1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4078_19797"
        x1="16"
        y1="17"
        x2="16"
        y2="14"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#63FFD1" />
        <stop offset="1" stopColor="#63FFD1" />
      </linearGradient>
    </defs>
  </svg>
)
